import { formatErrorForToast } from "../../../utils/reaErrorFormatter";

/**
 * Toast text for a Collings upload whose REA/portal row saved but whose CRM
 * Property create was refused. Carries the backend's reason (e.g. the
 * duplicate address a 409 names) instead of a bare "failed", so the agent
 * knows what happened rather than re-keying the form on the edit page.
 */
export const localRecordFailureMessage = (prefix, error) => {
  const data = error?.response?.data;
  const reason = data ? formatErrorForToast(data, 400) : "";
  const generic = `${prefix} but failed to create local record. Please refresh.`;
  if (!reason) return generic;
  return `${prefix} but the CRM record could not be created: ${reason}`;
};
